/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Images
import Mockup from '../../assets/images/panel/mockup.svg';
import Manage from '../../assets/images/panel/manage.svg';
import Type from '../../assets/images/panel/type.svg';
import Console from '../../assets/images/panel/console.svg';
import File from '../../assets/images/panel/file.svg';
import Online from '../../assets/images/panel/online.svg';

function cyperPanel() {
    return (
        <section className='cyperpanel py-28'>
            <div className="header max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 mb-24">
                <h1 className="text-gray-100 text-center text-3xl font-semibold mb-4">Cyperpanel</h1>
                <p className="text-gray-300 text-center">Our highly customized Pterodactyl control panel makes server management a breeze. Whether you're new to running a server or have a vast amount of experience, you'll find the control panel intuitive and rich with features.</p>
            </div>
            <div className="body max-w-7xl mx-auto px-5 sm:px-5 lg:px-5">
                <div className="bg-primaryDark py-10 px-3 rounded-xl">
                    <img src={Mockup} alt="Mockup" className='mx-auto mb-10' />
                    <div className='features'>
                        <h1 className='text-gray-300 font-semibold text-2xl text-center mb-9 lg:mb-6'>Features</h1>
                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-5 gap-y-9 items-center'>
                            <div>
                                <img src={Manage} alt="Manage" className='block mx-auto mb-4' />
                                <h1 className='text-gray-300 font-semibold text-center'>Manage your Server</h1>
                            </div>
                            <div>
                                <img src={Type} alt="Type" className='block mx-auto mb-4' />
                                <h1 className='text-gray-300 font-semibold text-center'>Change Server Type</h1>
                            </div>
                            <div>
                                <img src={Console} alt="Console" className='block mx-auto mb-4' />
                                <h1 className='text-gray-300 font-semibold text-center'>Advanced Console</h1>
                            </div>
                            <div>
                                <img src={File} alt="File" className='block mx-auto mb-4' />
                                <h1 className='text-gray-300 font-semibold text-center'>File Manager</h1>
                            </div>
                            <div>
                                <img src={Online} alt="Online" className='block mx-auto mb-4' />
                                <h1 className='text-gray-300 font-semibold text-center'>Always Online</h1>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </section>
    )
}

export default cyperPanel